
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customproductspertype_68e57999a5fe5912e600201f } from '../../api/productsdb.api'
import {getOnecertificationsdb } from '../../api/certificationsdb.api'

import './productspage.scss';






const Pproductspage = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyendpoint_68f16fe4a5fe5912e6005cb2, setLoftyEndpoint_68f16fe4a5fe5912e6005cb2] = useState({});
		const [loftyres_68e57999a5fe5912e600201f_component_ier434, setloftyres_68e57999a5fe5912e600201f_component_ier434] = useState([]);
	const [loftyres_68e57999a5fe5912e600201f_component_i3elr3, setloftyres_68e57999a5fe5912e600201f_component_i3elr3] = useState([]);
	const [loftyres_68e57999a5fe5912e600201f_component_isl6oo, setloftyres_68e57999a5fe5912e600201f_component_isl6oo] = useState([]);
	const [loftyres_68e57999a5fe5912e600201f_component_i8906x, setloftyres_68e57999a5fe5912e600201f_component_i8906x] = useState([]);
	const [loftyres_68e57999a5fe5912e600201f_component_iyl23t, setloftyres_68e57999a5fe5912e600201f_component_iyl23t] = useState([]);
	const [loftyres_68e57999a5fe5912e600201f_component_iqts8f, setloftyres_68e57999a5fe5912e600201f_component_iqts8f] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
			const loftyres_68f16fe4a5fe5912e6005cb2 = await getOnecertificationsdb({ _id: match.params._id, token: loftytoken || 'asdsa' });
			setLoftyEndpoint_68f16fe4a5fe5912e6005cb2(loftyres_68f16fe4a5fe5912e6005cb2.data);
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customproductspertype_68e57999a5fe5912e600201f({
				});
				setloftyres_68e57999a5fe5912e600201f_component_ier434(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customproductspertype_68e57999a5fe5912e600201f({
				});
				setloftyres_68e57999a5fe5912e600201f_component_i3elr3(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customproductspertype_68e57999a5fe5912e600201f({
				});
				setloftyres_68e57999a5fe5912e600201f_component_isl6oo(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customproductspertype_68e57999a5fe5912e600201f({
				});
				setloftyres_68e57999a5fe5912e600201f_component_i8906x(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customproductspertype_68e57999a5fe5912e600201f({
				});
				setloftyres_68e57999a5fe5912e600201f_component_iyl23t(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customproductspertype_68e57999a5fe5912e600201f({
				});
				setloftyres_68e57999a5fe5912e600201f_component_iqts8f(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  
  
  

  
  return (
    <div id="id68e6c55d8e5aed52dc7f0f53" >

      <div id="iw4j" className="">
      
      <div id="iwv3ah" className="">
      
      <div id="itmdc" className="">
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimggu1zyt.png"
        alt="undefined"
      />
      
      <div className="" id="iu1x7g">
        <>PETRUS GEMS</>
      </div>
      
      </div>
      
      <div id="ichr2q" className="">
      
        <a
          target=""
          className=""
          id="ijz73p"
          href="#"
        >
          
    <div id="ilqq9j" className="">
    <>+50488951552</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="ips2" className="">
      
      <div id="ikqj79" className="">
      
      <div id="iowj1k" className="">
      
      <a
        target=""
        className="link "
        id="il8xfg"
        href="/"
        type="button"
      >
        
    <div id="ihswfv" className="">
    <>INICIO</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iuicrj"
        href="/productos"
        type="button"
      >
        
    <div id="ih9i7g" className="">
    <>PRODUCTOS</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link "
        id="ib4wzs"
        href="/certificaciones"
        type="button"
      >
        
    <div id="ie4p6q" className="">
    <>CERTIFICACIONES</>
    </div>
    
      </a>
      
      <a
        target=""
        className="link "
        id="itj7od"
        href="/contacto"
        type="button"
      >
        
    <div id="i6b0kg" className="">
    <>CONTACTO</>
    </div>
    
      </a>
      
      </div>
      
      <div id="io8p1p" className="">
      
        <a
          target=""
          className=""
          id="ihd17v"
          href="/carritocompras"
        >
          
      <img
        className=""
        id="ic26eq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgjoujuz.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="if5pi" className="">
      
      <div className="" id="ibo0ei">
        <>Nuestros Productos</>
      </div>
      
      </div>
      
      </div>
      
      <div id="i3m0i" className="">
      
      <div id="iz2h6l" className="">
      
        <div className="" id="iuimt5" />
        
        <div className="" id="i4l654" />
        
        <div className="" id="ixl6es" />
        
        <div className="" id="igcwtg" />
        
        <div className="" id="ipm7tg" />
        
        <div className="" id="ilatjg" />
        
      </div>
      
      </div>
      
      <div id="i3dh" className="">
      
      <div id="ic7saw" className="">
      
        <div className="" id="izd4lz" />
        
      </div>
      
      <div id="i9qr9l" className="">
      
        <div className="" id="iawr7f" />
        
      </div>
      
      <div id="i8llzz" className="">
      
        <div className="" id="ilvdeg" />
        
      </div>
      
      <div id="i0l082" className="">
      
        <div className="" id="i8rio2" />
        
      </div>
      
      <div id="icr63j" className="">
      
        <div className="" id="iiylvk" />
        
      </div>
      
      <div id="i1cf0n" className="">
      
        <div className="" id="ir3y9j" />
        
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        <>Petrus Gems</>
      </div>
      
      <div className="" id="iygu8i">
        <>Elaboración de joyas de forma artesanal por mano de mujeres en nuestras comunidades</>
      </div>
      
      <div id="ix6pbo" className="">
      
        <a
          target=""
          className=""
          id="ibwuje"
          href="https://www.facebook.com/gemspetrus.hn"
        >
          
      <img
        className=""
        id="iy1qpk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgiadxwc.png"
        alt="undefined"
      />
      
        </a>
        
        <a
          target=""
          className=""
          id="iqvgxw"
          href="https://www.instagram.com/gemspetrus/"
        >
          
      <img
        className=""
        id="i26xh9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgiafdkq.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Enlaces Rápidos</>
      </div>
      
      <div id="iacot" className="">
      
      <a
        target=""
        className=""
        id="i2hsg"
        href="/"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <>Inicio</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/productos"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <>Productos</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/certificados"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <>Certificados</>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ixxmu"
        href="/contacto"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <>Contacto</>
    </div>
    
      </a>
      
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Contacto</>
      </div>
      
      <div id="iincid" className="">
      
      <span className="material-icons " id="iwlmju">
        
      <span className="material-icons " id="iz5z0g">
        <>call</>
      </span>
      
      </span>
      
      <div className="" id="i78qcc">
        <>+504 8895-1552</>
      </div>
      
      </div>
      
      <div id="idmnrv" className="">
      
      <span className="material-icons " id="i7tn5m">
        
      <span className="material-icons " id="isg8ci">
        
      <span className="material-icons " id="iuenok">
        <>mail</>
      </span>
      
      </span>
      
      </span>
      
      <div className="" id="il1rnw">
        <>handalcarl13@gmail.com</>
      </div>
      
      </div>
      
      <div id="i2jt24" className="">
      
      <span className="material-icons " id="il9zag">
        
      <span className="material-icons " id="iom84k">
        
      <span className="material-icons " id="i1y0v4">
        
      <span className="material-icons " id="iwl57t">
        <>my_location</>
      </span>
      
      </span>
      
      </span>
      
      </span>
      
      <div className="" id="i1at63">
        <>ubicacion</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pproductspage);
  